import { Transaction } from "@cede/types";
import { isDefiInfoTx } from "@cede/types";

export function getDefiSide(tx: Transaction) {
  if (isDefiInfoTx(tx.from)) return tx.from;
  if (isDefiInfoTx(tx.to)) return tx.to;
  // Cannot happen if that function is called in the fronted (and nothing is broken in between)
  throw new Error("Transaction does not have a defi side");
}
